<template>
    <div class="dashboard">
        <div v-if="(isAdmin || isAdminWholesaler || isPhReg || isAdminColian) && !isPreviewAdminMode" class="dashboard__wrapper">
            <div class="dashboard__background">
                <img src="~@/assets/images/dashboard-admin.png" alt="kasanowa" />
            </div>
            <KLayoutWrapper>
                <template #default>
                    <div>
                        <div v-if="isAdmin" class="dashboard__admin-title">{{ $t('dashboard.adminGonablePanel') }}</div>
                        <div v-if="isAdminColian" class="dashboard__admin-title">{{ $t('dashboard.adminPanel') }}</div>
                        <div v-if="isPhReg" class="dashboard__admin-title">{{ $t('dashboard.rksPanel') }}</div>
                        <div v-if="isAdminWholesaler" class="dashboard__admin-title">{{ $t('dashboard.wholesalerPanel') }}</div>
                        <AdminDashboard />
                    </div>
                </template>
            </KLayoutWrapper>
        </div>
        <div v-if="isPh || isPreviewAdminMode" class="dashboard__wrapper">
            <div class="dashboard__background dashboard__background--ph">
                <img src="~@/assets/images/dashboard-background.png" alt="kasanowa" />
            </div>
            <div class="dashboard__background-quiz">
                <img src="~@/assets/images/quiz-bgc.png" alt="kasanowa" />
            </div>

            <div class="dashboard__blue-elipse kasanowa-desktop">
                <img src="~@/assets/images/blue-elipse.png" alt="kasanowa" />
            </div>
            <div class="dashboard__yellow-elipse kasanowa-desktop">
                <img src="~@/assets/images/yellow-elipse.png" alt="kasanowa" />
            </div>

            <div class="dashboard__blue-elipse-2 kasanowa-desktop">
                <img src="~@/assets/images/blue-elipse.png" alt="kasanowa" />
            </div>
            <div class="dashboard__yellow-elipse-2 kasanowa-desktop">
                <img src="~@/assets/images/yellow-elipse.png" alt="kasanowa" />
            </div>
            <KLayoutWrapper>
                <template #default>
                    <div>
                        <PHDashboard />
                        <ProductsList />
                        <ArticleCarousel />
                        <QuizDashboard />
                    </div>
                </template>
            </KLayoutWrapper>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from '@vue/runtime-core';
import router from '@/router';
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/stores/user';
import { ROUTE_ADMIN_PREVIEW_QUERY } from '@/hooks/RouterHooks';
import KLayoutWrapper from '@/components/atoms/KLayoutWrapper.vue';
import AdminDashboard from '@/views/Dashboard/components/AdminDashboard.vue';
import PHDashboard from '@/views/Dashboard/components/PHDashboard.vue';
import ProductsList from '@/views/Dashboard/components/ProductsList.vue';
import ArticleCarousel from '@/views/Dashboard/components/ArticleCarousel.vue';
import QuizDashboard from '@/views/Dashboard/components/QuizDashboard.vue';

const { isAdmin, isPh, isPhReg, isAdminWholesaler, isAdminColian } = storeToRefs(useUserStore());
const isPreviewAdminMode = ref<boolean>(false);
if (router.currentRoute.value.query[ROUTE_ADMIN_PREVIEW_QUERY] === '1') {
    isPreviewAdminMode.value = true;
}
</script>

<style scoped lang="scss">
.dashboard {
    position: relative;
    width: 100%;

    &__wrapper {
        background: rgba($primary-800, 0.4);
        backdrop-filter: blur(5px) saturate(150%);
        -webkit-backdrop-filter: blur(5px) saturate(150%);
        position: relative;
        width: 100%;
        overflow: hidden;
    }

    &__background {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
        width: 100%;
        height: 100%;

        img {
            object-fit: cover;
            width: 100%;
            height: calc(100% - 184px);
            min-height: calc(100vh - 184px);

            @include media-breakpoint-up(lg) {
                height: calc(100% - 217px);
                min-height: calc(100vh - 217px);
            }
        }

        &--ph {
            img {
                object-fit: cover;
                height: auto;
                min-height: 580px;
            }
        }
    }

    &__background-quiz {
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 0;
        width: 100%;
        height: max-content;

        img {
            object-fit: cover;
            height: auto;
            min-height: 760px;

            @include media-breakpoint-up(md) {
                min-height: 820px;
            }

            @include media-breakpoint-up(lg) {
                min-height: 1050px;
            }
        }
    }

    &__admin-title {
        background-color: $primary-400;
        color: $black;
        font-weight: 1000;
        padding: 8px;
        text-transform: uppercase;
        font-size: 20px;
        text-align: center;
        max-width: 520px;
        margin: 0 auto;

        @include media-breakpoint-up(lg) {
            font-size: 40px;
            padding: 18px 24px;
            max-width: 900px;
        }
    }

    &__blue-elipse {
        position: absolute;
        top: 230px;
        right: -540px;
        z-index: 0;
        width: 100%;
        height: max-content;

        img {
            object-fit: cover;
            height: auto;
        }
    }

    &__yellow-elipse {
        position: absolute;
        top: 0;
        left: -540px;
        z-index: 0;
        width: 100%;
        height: max-content;

        img {
            object-fit: cover;
            height: auto;
        }
    }

    &__blue-elipse-2  {
        position: absolute;
        bottom: 310px;
        left: -540px;
        z-index: 0;
        width: 100%;
        height: max-content;

        img {
            object-fit: cover;
            height: auto;
        }
    }

    &__yellow-elipse-2 {
        position: absolute;
        bottom: 440px;
        right: -730px;
        z-index: 0;
        width: 100%;
        height: max-content;

        img {
            object-fit: cover;
            height: auto;
        }
    }
}
</style>
